import ModalVideo from 'modal-video';

class VideoLink {
    constructor(el) {
        this.el = el;
        this.channel = this.el.data('channel') || 'youtube';
        this.modal = new ModalVideo(this.el, {
            channel: this.channel
        });
    }
}

export default VideoLink;